(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.slides = Array.from(this.querySelectorAll('[data-index]'));
      this.thumbsTrack = this.querySelector('[data-thumbs-track]');
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb-index]'));
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.cursor = this.querySelector('[data-carousel-cursor]');
      this.desktopInteractionQuery = window.matchMedia('(min-width: 62em) and (hover: hover) and (pointer: fine)');

      if (!this.track) return;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this.goToSlide(Number(thumb.dataset.thumbIndex));
        });
      });

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.stepSlide(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.stepSlide(1));

      this.track.addEventListener('scroll', () => {
        this.syncActiveThumb();
        this.updateArrows();
      }, { passive: true });

      if (this.slides.length > 1 && this.cursor) {
        this.track.addEventListener('mousemove', (event) => this.updateCursor(event));
        this.track.addEventListener('mouseleave', () => this.hideCursor());
        this.track.addEventListener('click', (event) => this.handleTrackClick(event));
      }

      this.updateArrows();
    }

    getCurrentIndex() {
      if (!this.track.clientWidth) return 0;
      return Math.round(this.track.scrollLeft / this.track.clientWidth);
    }

    goToSlide(index, behavior = 'smooth') {
      const slide = this.slides[index];
      if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft, behavior });
      this.setActiveThumb(index);
      this.updateArrows(index);
    }

    setActiveMedia(mediaId, behavior = 'auto') {
      const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (index === -1) return;
      this.goToSlide(index, behavior);
    }

    stepSlide(direction) {
      const targetIndex = this.getCurrentIndex() + direction;
      if (targetIndex < 0 || targetIndex > this.slides.length - 1) return;
      this.goToSlide(targetIndex);
    }

    syncActiveThumb() {
      this.setActiveThumb(this.getCurrentIndex());
    }

    setActiveThumb(index) {
      this.thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === index);
      });
      const activeThumb = this.thumbs[index];
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }
    }

    updateArrows(index) {
      if (!this.prevButton && !this.nextButton) return;
      const currentIndex = index === undefined ? this.getCurrentIndex() : index;
      if (this.prevButton) this.prevButton.disabled = currentIndex <= 0;
      if (this.nextButton) this.nextButton.disabled = currentIndex >= this.slides.length - 1;
    }

    updateCursor(event) {
      if (!this.desktopInteractionQuery.matches) {
        this.hideCursor();
        return;
      }

      const rect = this.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const isNext = x > rect.width / 2;
      this.cursor.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
      this.cursor.classList.toggle('page-product__gallery-cursor--next', isNext);
      this.cursor.classList.toggle('page-product__gallery-cursor--prev', !isNext);
      this.cursor.classList.add('is-visible');
    }

    hideCursor() {
      this.cursor.classList.remove('is-visible');
    }

    handleTrackClick(event) {
      if (!this.desktopInteractionQuery.matches) return;

      const rect = this.getBoundingClientRect();
      const x = event.clientX - rect.left;
      this.stepSlide(x > rect.width / 2 ? 1 : -1);
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
